import { render, staticRenderFns } from "./S.vue?vue&type=template&id=0a1ae17a&scoped=true&"
import script from "./S.vue?vue&type=script&lang=js&"
export * from "./S.vue?vue&type=script&lang=js&"
import style0 from "./S.vue?vue&type=style&index=0&id=0a1ae17a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ae17a",
  null
  
)

export default component.exports